module.exports = __webpack_public_path__ + "static/img/20210924181911.9e82ce55.png";